"use strict";

angular.module("customer")
.controller("SectionRegistration", function(
    $scope, $rootScope, $state, $stateParams, gettextCatalog, FlashBag, FormError, $http, Language, PartnershipService,
    GroupService, UserService, PatternService, RegistrationService, moment, CUSTOMER_TYPE_REGISTRATION, CUSTOMER_TYPE,
    IS_MOBILE, IS_TABLET, EMAIL_MAXLENGTH, appConfig
) {
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.isCustomerTypeBusiness = CUSTOMER_TYPE_REGISTRATION == CUSTOMER_TYPE["BUSINESS"];
    $scope.isMobileRegistration = IS_MOBILE && !IS_TABLET;

    $scope.pattern = PatternService;
    $scope.shortLanguage = Language.getLanguage();

    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        $scope.shortLanguage = short_code;
    });
    Language.getLanguages().then(function(response) {
        $scope.Languages = response.data;
    });

    if ($stateParams.token) {
        $scope.User = RegistrationService.fillUserWithTokenInvitationInfo($stateParams.token);
    }
    else {
        RegistrationService.checkForAutoRedirectPage();
        $scope.User = {
            Token: "",
            departments: []
        };
    }

    $scope.User.timezone = moment.tz.guess();

    function affectLanguage(shortCode) {
        for (var index in $scope.Languages) {
            if ($scope.Languages[index].ShortCode == shortCode) {
                $scope.User.LanguageID = $scope.Languages[index].id;
                break;
            }
        }
    }

    this.create = function() {
        $scope.isFormSubmit = true;

        FlashBag.clearAll();
        this.validate();

        if (!$scope.SetRegister) {
            return;
        }

        if (
            $scope.SetRegister.$valid
            || ($scope.SetRegister.Username.$error.invalid || $scope.SetRegister.Email.$error.used)
        ) {
            this.registerUser();
        }
    };

    this.validate = function() {
        FormError.focus("SetRegister");
    };

    this.registerUser = function() {
        affectLanguage($scope.shortLanguage);
        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/auth/user/",
            data: angular.extend({}, {
                Action: "Register",
                RegistrationType: "Customer",
                is_from_quick_registration_page: true,
                customer_type: CUSTOMER_TYPE_REGISTRATION,
                groupInvite: $stateParams.groupInvite,
                vendorInvite: $stateParams.vendorInvite,
                vendor: $stateParams.vendor || $stateParams.stocks,
                is_mobile_registration: $scope.isMobileRegistration
            }, $scope.User)
        }).then(function onSuccess(response) {
            UserService.persistAuthTokenWithoutUserRefresh(response);
            if ($stateParams.vendorInvite) {
                PartnershipService.add({"vendorInvite": $stateParams.vendorInvite}).then(
                    function success(response) {
                        FlashBag.success(response.detail, true);
                    },
                    function failed(response) {
                        FlashBag.apiError(response, true);
                    }
                );
            }

            GroupService.addCustomerGroupMembershipFromRegistration($stateParams.groupInvite);

            UserService.refreshCurrentUser().then(function() {
                if ($stateParams.stocks) {
                    $state.go("stocks", {vendor: $stateParams.stocks, catalog: $stateParams.catalog});
                }
                else if ($stateParams.vendor) {
                    $state.go("stocks", {vendorId: $stateParams.vendor});
                }
                else if ($stateParams.product) {
                    $state.go("stocks", {product: $stateParams.product});
                }
                else if ($stateParams.invoice) {
                    $state.go("invoiceDetails", {id: $stateParams.invoice});
                }
                else if ($stateParams.payment) {
                    $state.go("paymentDetails", {id: $stateParams.payment});
                }
                else if ($stateParams.unpaid_invoices) {
                    $state.go("payment", {selected: $stateParams.unpaid_invoices});
                }
                else if (CUSTOMER_TYPE_REGISTRATION == CUSTOMER_TYPE["PERSON"]) {
                    $state.go("customer-edit")
                }
                else {
                    $state.go("home");
                }
            });

            FlashBag.success(gettextCatalog.getString("Your account was created successfully."), true);
        },
        function onError(response) {
            FlashBag.apiError(response);

            if (!$scope.SetRegister) {
                return;
            }

            if (response.data["Email"]) {
                $scope.SetRegister.Email.$setValidity("used", false);
            }
            else {
                $scope.SetRegister.Email.$setValidity("used", true);
            }

            if (response.data["Username"]) {
                $scope.SetRegister.Username.$setValidity("invalid", false);
            }
            else {
                $scope.SetRegister.Username.$setValidity("invalid", true);
            }
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/auth/quick-registration.controller.js
// module id = 894
// module chunks = 0